export function LocationFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 10a8 8 0 1116 0c0 1.155-.366 2.466-.888 3.731-.528 1.281-1.248 2.593-2.028 3.77-.778 1.176-1.635 2.249-2.45 3.04a7.431 7.431 0 01-1.234.996c-.39.241-.878.463-1.4.463-.522 0-1.01-.222-1.4-.463a7.43 7.43 0 01-1.235-.995c-.814-.792-1.671-1.865-2.449-3.04-.78-1.178-1.5-2.49-2.028-3.771C4.366 12.466 4 11.155 4 10zm8 3a3 3 0 100-6 3 3 0 000 6z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
